<template>
<div>
  <div>
    <el-descriptions size="mini" :label-style="{width: '100px'}" :column="1" border>
      <el-descriptions-item label="装修备案表">
        <el-descriptions size="mini" :label-style="{width: '100px'}" direction="vertical" :column="2" border>
          <el-descriptions-item label="模板下载">
            <el-link type="primary" style="min-width: 250px;" @click="dowBeiAnExcel">《装修备案表》模板</el-link>
          </el-descriptions-item>
          <el-descriptions-item label="文件上传">
            <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="装修备案表" />
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
      <el-descriptions-item label="三方协议">
        <el-descriptions size="mini" :label-style="{width: '100px'}" direction="vertical" :column="2" border>
          <el-descriptions-item label="模板下载">
            <el-link type="primary" style="min-width: 250px;" @click="dowSanFangExcel">《三方协议》模板</el-link>
          </el-descriptions-item>
          <el-descriptions-item label="文件上传">
            <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="三方协议" />
          </el-descriptions-item>
        </el-descriptions>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</div>
</template>

<script>
import FlowHttp from "../../common/FlowHttp";
import Http from "../../common/Http";
import FitmentFileSubgroup from "./components/FitmentFileSubgroup";

export default {
  name: "FurnishTripleAgreement",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      form:{}
    }
  },
  activated() {
    this.getData()
  },
  mounted() {
    this.getData()
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getFurnish",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.setProcessState(ret.data.ProcessState);
          that.form=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
    dowBeiAnExcel(){
      if(!this.mainObj.house_id){
        this.$Message.error('点击左边树选择项目!');
        return false;
      }
      const that = this;
      ERP.showLoading()
      FlowHttp.post('house/HouseFurnish/getFurnishFilings',{house_id:that.mainObj.house_id,id:that.mainObj.id},ret=>{
        ERP.hideLoading()
        if(ret.code){
          window.open(FlowHttp.getBaseURL() +ret.data)
        }
      })
    },
    dowSanFangExcel(){
      const that = this;
      // window.open(FlowHttp.getBaseURL() +"/word_template/san_fang_xie_yi.docx");

      if(!this.mainObj.house_id){
        this.$Message.error('点击左边树选择项目!');
        return false;
      }
      ERP.showLoading()
      FlowHttp.post('house/HouseFurnish/getTripleAgreement',{house_id:that.mainObj.house_id,id:that.mainObj.id},ret=>{
        ERP.hideLoading()
        if(ret.code){
          window.open(FlowHttp.getBaseURL() +ret.data)
        }
      })
    },

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/FurnishTripleAgreement.vue